
import _ from 'lodash'

export const useQrcodeMenuSetting = (fullGroups, qrMenuSetMap = {}, isEmployee) => {

    let toUsePrductIdMap = ref(qrMenuSetMap);

    let _res = computeGroup(fullGroups)
    let groups = ref(_res)

    let _isEmployee = ref(isEmployee)
    if (_isEmployee.value == 'employee') {
        groups.value = fullGroups
    }

    function computeGroup(groups) {

        let groupCloned = _.cloneDeep(groups)
        
        let res = []
        for (let i = 0; i < groupCloned.length; i++) {
            let group = groupCloned[i]
            if (toUsePrductIdMap.value[group.productId]) {
                res.push(group)
                continue
            }

            //Fix bug not have items
            if(group.items===undefined){
                continue
            }
           
            let _items = []            
            for (let j = 0; j < group.items.length; j++) {
                let item = group.items[j]
                if (toUsePrductIdMap.value[item.productId]) {
                    _items.push(item)
                }
            }

            if (_items.length >= 1) {
                group.items = _items
                res.push(group)
                continue
            }
        }

        return res
    }
     

    function getFullItemsList() {

        if (_isEmployee.value == 'employee') {
            return getMenuItems()
        }


        let res = []

        for (let i = 0; i < groups.value.length; i++) {
            let group = groups.value[i]
            if(toUsePrductIdMap.value[group.productId]) { 
                if(group.items!==undefined){
                    res.push(...group.items)
                }                
                continue
            }
            for (let j = 0; j < group.items.length; j++) {
                let item = group.items[j]
                if (toUsePrductIdMap.value[item.productId]) {
                    res.push(item)
                }
            }
           
        }

        return res
    }

    function getMenuItems() {
        const _groups = groups.value;
        const itemMenuList: Array<any> = [];
        _.forEach(_groups, (og: any) => {
            const optionsItems = _.cloneDeep(og.items);
            itemMenuList.push(optionsItems);
        });

        return itemMenuList;
    };

    return {
        groups,
        getFullItemsList,
    }

}